export default "__VITE_ASSET__011ece44__"